import { toast } from "sonner";

type ToasterPosition =
  | "top-left"
  | "top-right"
  | "bottom-left"
  | "bottom-right"
  | "top-center"
  | "bottom-center";

const ShowToaster = {
  success: (msg: string, position: ToasterPosition = "top-right") =>
    toast.success(msg, { position }),
  error: (msg: string, position: ToasterPosition = "top-right") =>
    toast.error(msg, { position }),
  info: (msg: string, position: ToasterPosition = "top-right") =>
    toast.info(msg, { position }),
  warning: (msg: string, position: ToasterPosition = "top-right") =>
    toast.warning(msg, { position }),
};

export default ShowToaster;
